import React from "react";
import "./DoctorAutoComplete.scss";

const DoctorAutoComplete = ({
  onFsListItem,
  setBtnTitle,
  isDisabled,
  type = [],
}) => {
  // const [type, setType] = useState(appointmentTypeData);

  // const onAppointmentList = (item) => {
  //   const tempApp = [...appointmentTypeData];
  //   tempApp.map((typeItem, typeIdx) => {
  //     if (typeItem.id === item.id) {
  //       setBtnTitle(item.title);
  //       typeItem.isSelect = true;
  //     } else {
  //       typeItem.isSelect = false;
  //     }
  //   });
  //   setType(tempApp);
  //   setIsAppModal(false);
  // };

  return (
    <div className="ne_dropdown_menu">
     <ul className="ne_dropdown_list px-3">
  {type
    .filter((appTypItem) => appTypItem.active !== false) // Only show items where active is true or undefined
    .map((appTypItem, idx) => {
      return (
        <li
          className="ne-scope p-2 p-0"
          key={idx}
          onClick={() => onFsListItem(appTypItem)}
        >
          <a className="ne_dropdown_item">
            <span className="ne-binding">
              {"templateName" in appTypItem
                ? appTypItem.templateName
                : `${appTypItem.templateName}  ${
                    appTypItem.id ? `:: ${appTypItem.id}` : ""
                  }`}
            </span>
          </a>
        </li>
      );
    })}
</ul>

    </div>
  );
};
export default DoctorAutoComplete;
